// extracted by mini-css-extract-plugin
module.exports = {"select":"styles_select__3CpCz","option":"styles_option__1UDOg","flagIcon":"styles_flagIcon__3AbQr"};